import React from 'react';
import { Routes, Route } from "react-router-dom";
import AttendeeLayout from '../Layout/Attendeeindex';
import Home from '../Components/Attendee/AttendeeHome';

export default function AttendeeRoutes(){
    return(
        <Routes >
        <Route element={<AttendeeLayout />}>      
          <Route path="attendeehome" element={<Home />} />
        </Route>
      </Routes>
    )
}

 